import { storeToRefs } from "pinia"
import { useAppStore } from "@/stores/app"

class ShowUpgradeModal {
  static apply() {
    const { showModalUpgradeToPro } = storeToRefs(useAppStore())

    showModalUpgradeToPro.value = true
  }
}

export default ShowUpgradeModal
